export default __webpack_public_path__ + "static/media/meals.7ca249aa.png";